module.exports = __webpack_public_path__ + "static/media/WebStorm.2a34fc86.png";